import { h, render } from 'preact';

function standardizeTagName(tagName) {
  return tagName.trim().toLowerCase();
}

function mountToNode(node, component) {
  const props = {};

  for (let index = 0; index < node.attributes.length; index++) {
    const attribute = node.attributes[index];
    props[attribute.name] = attribute.value;
  }

  if (props.hasOwnProperty('container')) {
    throw new Error(
      `'container' cannot be use as an attribute for ${elm.tagName}`,
    );
  }

  if (props.hasOwnProperty('children')) {
    throw new Error(
      `'children' cannot be use as an attribute for ${elm.tagName}`,
    );
  }

  props.container = node;
  props.children = Array.prototype.slice.call(node.childNodes, 0);

  render(h(component, props), node);
}

export default (tagName = '', component = undefined) => {
  tagName = standardizeTagName(tagName);

  Array.prototype.slice
    .call(document.querySelectorAll(tagName), 0)
    .forEach((node) => {
      mountToNode(node, component);
    });
};
